import SettingButtons from "Components/SettingButtons/SettingButtons";
import { useToggleNotificationMutation } from "Data/services/userAuthApi";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TriangleIcon } from "svg";
import { WEB_ROUTES } from "../../constants";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/settings.module.scss";
import { useAppSelector } from "Hooks/useReduxTypeHooks";
import { SuccessToast } from "Hooks/useToast";

interface SettingModalProps {
  handleSettingModalClose: () => void;
  logoutModalHandler: () => void;
  deleteUserModalHandler: () => void;
}

const SettingModal: React.FC<SettingModalProps> = ({
  handleSettingModalClose,
  logoutModalHandler,
  deleteUserModalHandler,
}) => {
  const navigate = useNavigate();
  // const [notification, setNotification] = useState<boolean>(true);
  // const [loading, setLoading] = useState<boolean>(false);

  const [toggleNotificaiton, { isLoading, isSuccess }] =
    useToggleNotificationMutation();

  useEffect(() => {
    if (isSuccess) {
      SuccessToast("Notification status changed successfully.");
    }
  }, [isSuccess]);

  const authUser = useAppSelector((state) => state.auth.user);
  // console.log(authUser);

  return (
    <div>
      <ModalContainer handleClose={handleSettingModalClose} dropShadow={true}>
        <div className={cssStyles.modalContainer}>
          <div className={cssStyles.triangle}>
            <TriangleIcon />
          </div>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0">Settings</p>
            {/* <FaCircleXmark onClick={handleSettingModalClose} style={{ cursor: 'pointer' }} /> */}
          </div>

          <SettingButtons
            text="Edit Profile"
            clickHandler={() => {
              // console.log("Edit Profile");
              navigate(WEB_ROUTES.EDIT_PROFILE);
              handleSettingModalClose();
            }}
          />
          <SettingButtons
            text="Push Notifications"
            hasButton={true}
            isLoading={isLoading}
            isChecked={!!authUser?.push_notification}
            clickHandler={() => {
              // setLoading(true);
              // setTimeout(() => {
              //   setNotification((prev) => !prev);
              //   setLoading(false);
              // }, 2000);
              toggleNotificaiton();
            }}
          // clickHandler={() => toggleNotificaiton()} //todo:
          />
          <SettingButtons
            text="Change Password"
            clickHandler={() => {
              // console.log("Change Password");
              navigate(WEB_ROUTES.CHANGE_PASSWORD);
              handleSettingModalClose();
            }}
          />
          <SettingButtons
            text="Delete Account"
            clickHandler={() => {
              // console.log("Delete Account");
              handleSettingModalClose();
              deleteUserModalHandler();
            }}
          />
          <SettingButtons
            text="Logout"
            bgColor="#FF5757"
            textColor="#ffffff"
            isLogout={true}
            clickHandler={() => {
              // console.log("Logout");
              handleSettingModalClose();
              logoutModalHandler();
            }}
          />
        </div>
      </ModalContainer>
    </div>
  );

  // function Notification() {
  //     return <div className='d-flex align-items-center w-100 justify-content-start'>

  //         <div className=' rounded-5 d-flex justify-content-center align-items-center' style={{ backgroundColor: '#222232', width: '50px', height: '50px' }}>
  //             <FaBell />
  //         </div>

  //         <div className='ms-3'>
  //             <p className='fs-6 fw-semibold m-0'>Lorem Ipsum</p>
  //             <p className='m-0 fs-8'>Lorem ipsum dolor sit amet</p>
  //         </div>

  //     </div>;
  // }
};

export default SettingModal;
